import {
  DeploymentStageName,
  LogLevel,
  TargetUserGroup,
} from '@trustedshops/tswp-core-common';

export const environment = {
  production: true,
  name: DeploymentStageName.QA,
  targetGroup: TargetUserGroup.BusinessToBusiness,
  pageTitle: 'eTrusted Control Centre',
  tracking: {
    googleAnalytics4: 'G-E3DQ4T285P',
    hubspot: {
      id: '603347',
      scriptUrl: '//js.hs-scripts.com/603347.js',
    },
    msClarity: {
      projectId: 'tjqb8n1le2',
    },
  },
  apis: {
    plugins: 'https://app-api.etrusted.site/v0',
    permissions: 'https://b2b-permissions-qa.trustedshops.com/v1',
    users: 'https://sso-apis-qa.etrusted.com/um-v1',
    accounts: 'https://api.etrusted.site',
    featureBooking: 'https://booking-api.etrusted.site/v0',
    productFeature: 'https://platform-apis-b2b-qa.etrusted.com/pfm-v1',
    tsns: 'https://tsns-api-qa.trustedshops.com/v1',
    monthlyReviewCountGoal:
      'https://dashboard-api.insights.etrusted.site/v2/goal/monthly/reviews-count',
    channelSeoSettings:
      'https://profile-configurator-api.seo-qa.trustedshops.com/v2',
    channelInvitesReminder: 'https://api.etrusted.site',
    businessHubB2B:
      'https://business-hub-b2b.revenue-operations-test.trustedshops.com',
    shops: '/companies/{id}/shops',
    company: '/companies/{id}',
  },
  startPage: {
    url: '/home',
  },
  diagnostics: {
    logging: {
      logLevels: [LogLevel.Warning, LogLevel.Error, LogLevel.Fatal],
      filters: [],
      sentry: {
        environment: DeploymentStageName.QA,
        logLevels: [LogLevel.Error, LogLevel.Fatal],
        dsn: 'https://ad6c7ff7bab74ba1a5923520c97a6e42@o128203.ingest.sentry.io/5614223',
        browserTracingOrigins: [
          'app-qa.trustedshops.com',
          'app-api-qa.trustedshops.com',
          'app.etrusted.site',
          'app-api.etrusted.site',
          'api.etrusted.site',
          'admin.etrusted.site',
        ],
      },
      instana: {
        logLevels: [LogLevel.Error, LogLevel.Fatal],
        browserTracingOrigins: [],
        reportingUrl: 'https://eum-blue-saas.instana.io',
        key: 'UK4fSW93Q2G6EAvODUAL_g',
        allowedOrigins: [
          /.*sso-apis-b2b-qa.etrusted.com.*/i,
          // /.*login-qa.etrusted.com.*/i,
          /.*sso-client-b2b-qa.etrusted.com.*/i,
          // /.*task-management-qa.trustedshops.com.*/i,
          // /.*api.etrusted.site.*/i,
          /.*cns-qa.trustedshops.com.*/i,
        ],
        scriptUrl: 'https://eum.instana.io/1.8.1/eum.min.js',
      },
    },
  },
  authorization: {
    keycloakUrl: 'https://login-qa.etrusted.com/auth/',
    clientId: 'tswp-carrier-b2b',
    realm: 'business-QA',
    sessionVerificationType: 'check-sso',
    silentCheckSsoRedirectUri: '/assets/authentication/token-proxy.html',
  },
  layout: {
    resources: {
      heliosUri: 'https://app.etrusted.site/helios.css',
      heliosIconUri:
        'https://cdn-qa.trustedshops.com/helios/helios-icons/1.7.20/raw/',
    },
  },
  storage: {
    plugins: {
      rootPath: 'https://app.etrusted.site/plugins',
    },
  },
  feedback: {
    api: 'https://api.etrusted.site/nps-questionnaire-link',
    templateBase: 'tpl-qst-46d24265-bf2c-4b2d-b35b-2b19f6c153bc_',
  },
  freeAccount: {
    hubspot: {
      upgradePage: {
        baseUrl: 'https://api.hsforms.com',
        authToken: 'pat-na1-1ef73205-7556-4d23-86b4-699de9408909',
        portalId: '21303160',
        fullContactFormId: '8258e5b1-7dd5-49a1-a9a1-82d972fb5c6c',
        shortContactFormId: '25ee45cd-5070-44b3-a75f-b6767fb6dcae',
        ctaContactFormId: '60c1ee9b-f27b-45b4-847b-653087e4a9b2',
      },
    },
  },
  userFlow: {
    proxyApi: 'https://platform-apis-b2b-qa.etrusted.com/userflow-proxy-v1',
    apiKey: 'ct_r36fodd4bjh6xg7oyqdougtydi',
    freeAccountChecklistId: '374ecae6-7093-4b02-95d3-510a2c1c70ae',
    paidAccountChecklistId: 'd33f09db-9cb4-46c7-9ba8-75dca0576631',
    advancedPaidAccountChecklistId: 'd0111d7d-e39a-4901-9b31-720d520265fc',
    // Use `nischay.papneja+123987@trustedshops.com` to test paid accounts onboarding
    // which were created AFTER the release of the paid accounts onboarding feature.
    // Use `developer_fr@trustedshops.de` to test paid accounts onboarding
    // which were created BEFORE the release of the paid accounts onboarding feature.
    paidAccountsOnboardingReleaseDate: '2025-05-26T00:00:00.000Z',
  },
  kameleoon: {
    clientParameters: {
      siteCode: 'rgs96wluz1',
      configuration: {
        updateInterval: 1,
        environment: 'qa',
        cookieDomain: 'app.etrusted.site',
      },
    },
  },
  upgradeJourney: {
    comparePlansUrl:
      'https://business.trustedshops.de/packages-prices-trusted-shops?hs_preview=VXCXgUuY-208565160358',
  },
};
